import i18n from './i18n';
import config from './config';

let routes = {};

i18n.on('initialized', () => {
  routes = {
    en: {
      apprenticeships: config.baseUrl.en + '/' + i18n.t('local:route.apprenticeships', {lng: 'en'}),
      apprenticeshipSearch: '/',
      results: '/' + i18n.t('local:route.results', {lng: 'en'}),
      detail: '/' + i18n.t('local:route.results', {lng: 'en'})+ '/:apprenticeship'
    },
    cy: {
      apprenticeships: config.baseUrl.en + '/' + i18n.t('local:route.apprenticeships', {lng: 'cy'}),
      apprenticeshipSearch: '/',
      results: '/' + i18n.t('local:route.results', {lng: 'cy'}),
      detail: '/' + i18n.t('local:route.results', {lng: 'cy'})+ '/:apprenticeship'
    }
  }
});

export function route(name, parameters = null, language = i18n.language) {
  if (parameters) {
    return routes[language][name].split('/').map(fragment => {
       return fragment.startsWith(':') ? parameters[fragment.substr(1)] : fragment;
    }).join('/');
  }

  return routes[language][name];
}
